
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppSelect, AppButton } from '@/components';
import { usePromotionCode } from '@/modules/promotion/code/model/list';
import { InjectionFeature } from '@/common/reward/types';
import { getRewardRouteToIndexPage } from '@/common/reward/route.registry';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.CODE.INDEX,
    components: { AppTable, AppCard, AppSelect, AppButton },
    setup() {
        const { featureId, list, total, query, fetchList, actions, Options } = usePromotionCode();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Code', key: 'code' },
                { type: TableColumnType.Option, label: 'Feature', key: 'feature', options: Options.features },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' },
                { type: TableColumnType.Text, label: 'Receive Counter', key: 'receiveCounter' },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: Options.statusList },
                { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_PROMOTION.CODE.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onclick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onclick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return {
            featureId,
            table,
            list,
            total,
            query,
            fetchList,
            actions,
            Options,
            ROUTE_NAME_PROMOTION,
            InjectionFeature,
            getRewardRouteToIndexPage
        };
    }
});
